import axios from "axios";
import { API } from "../config";
import {
  MENU_LIST_REQUEST,
  MENU_LIST_SUCCESS,
  MENU_LIST_FAILURE,
  MENU_ITEM_UPDATE_REQUEST,
  MENU_ITEM_UPDATE_SUCCESS,
  MENU_ITEM_UPDATE_FAILURE,
} from "../constants/menuConstants";

const MENU_STORE_SLUG = "ajna";

export const getMenu = (categoryId = null) => async (dispatch, getState) => {
  try {
    dispatch({ type: MENU_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const outletId = userInfo?.user?.erp_user?.outlet;
    const params = new URLSearchParams();
    if (outletId != null) params.set("outlet_id", outletId);
    if (categoryId != null && categoryId !== "") params.set("category_id", categoryId);
    const query = params.toString();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const url = query
      ? `${API}/api/products/menu/${MENU_STORE_SLUG}?${query}`
      : `${API}/api/products/menu/${MENU_STORE_SLUG}`;
    const { data } = await axios.get(url, config);

    // Response: { success: "true", message: "Product Categories Retrieved Successfully", data: [] }
    const ok = data.success === "true" || data.success === true;
    if (!ok) {
      dispatch({
        type: MENU_LIST_FAILURE,
        payload: data.message || "Failed to load menu.",
      });
      return;
    }

    const items = Array.isArray(data.data) ? data.data : [];
    dispatch({
      type: MENU_LIST_SUCCESS,
      payload: items,
    });
  } catch (error) {
    dispatch({
      type: MENU_LIST_FAILURE,
      payload:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message,
    });
  }
};

// POST menu/status/toggle — Body: { outlet, product, product_variant? }
// item = product from category.sub_categories[].products[] (has id, name, is_active, etc.)
export const updateMenuItem = (item) => async (dispatch, getState) => {
  const productId = item.id ?? item.product ?? item.product_id;
  const variantId = item.product_variant ?? item.variant_id ?? null;
  const updatingKey = `${productId}-${variantId ?? ""}`;

  try {
    dispatch({ type: MENU_ITEM_UPDATE_REQUEST, payload: updatingKey });

    const {
      userLogin: { userInfo },
    } = getState();

    const outletId = userInfo?.user?.erp_user?.outlet;
    if (outletId == null) {
      dispatch({
        type: MENU_ITEM_UPDATE_FAILURE,
        payload: { updatingKey, error: "Outlet not found for user." },
      });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const body = {
      outlet: Number(outletId),
      product: productId,
      ...(variantId != null && variantId !== "" && { product_variant: variantId }),
    };

    await axios.post(`${API}/api/products/menu/status/toggle`, body, config);

    const currentActiveFromProduct =
      item.is_active !== undefined ? item.is_active !== false : null;
    const currentActiveFromStorePrice =
      currentActiveFromProduct === null &&
      Array.isArray(item.store_product_price) &&
      item.store_product_price.length > 0
        ? item.store_product_price[0].is_active !== false
        : null;
    const currentActive =
      currentActiveFromProduct !== null
        ? currentActiveFromProduct
        : currentActiveFromStorePrice !== null
        ? currentActiveFromStorePrice
        : true;
    const nextActive = !currentActive;
    dispatch({
      type: MENU_ITEM_UPDATE_SUCCESS,
      payload: {
        product: productId,
        product_variant: variantId,
        is_active: nextActive,
      },
    });
  } catch (error) {
    dispatch({
      type: MENU_ITEM_UPDATE_FAILURE,
      payload: {
        updatingKey,
        error:
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.message,
      },
    });
  }
};
